export default __webpack_public_path__ + "static/media/footer_pc@2x.35a77381.png";